export default __webpack_public_path__ + "static/media/img-slider-ommerchant-5.41cacbc2.png";